module.exports = __webpack_public_path__ + "img/16-fourImg.4eceb980.png";